<template>
    <div>
        
        <b-row>
            <b-img  class="fons" src="@/images/fons_pantalla.jpg"></b-img>
            <div class="capcalera">
                <h1 class="titol">No t'escapis de la indústria</h1>
                <h3 class="subtitol">Benvinguts al joc d'orientació i descoberta de la indústria i de la formació professional. Divertiu-vos molt i a produir!</h3>
            </div>
            <b-col :cols="$mq | mq({ mobile: 6, tablet: 6, laptop: 3, desktop:2 })" class="lang_icon_cat">  
                <b-row align-h="center">
                    <h1 style="color:#000000"><strong>Català</strong></h1>
                </b-row>
                <b-row align-h="center">
                    <!-- <b-img  @click="gotoLang('ca')" src="@/images/icon_lang_catala.png" title="Català" fluid></b-img> -->
                    <b-button @click="gotoLang('ca')" variant="success"><h3 style="color:#ffffff"><strong>Començar joc</strong></h3></b-button>
                </b-row>
            </b-col>
            <b-col :cols="$mq | mq({ mobile: 6, tablet: 6, laptop: 3, desktop:2 })" class="lang_icon_esp">  
                <b-row align-h="center">
                    <h1 style="color:#000000"><strong>Castellano</strong></h1>
                </b-row>                
                <b-row align-h="center">
                    <b-button @click="gotoLang('es')" variant="success"><h3 style="color:#ffffff"><strong>Empezar juego</strong></h3></b-button>
                    <!-- <b-img  @click="gotoLang('es')" src="@/images/icon_lang_castellano.png" title="Castellano" fluid></b-img> -->
                </b-row>
                
            </b-col>
        </b-row>
        <b-row>
            <b-col :cols="$mq | mq({ mobile: 6, tablet: 6, laptop: 3, desktop:2 })" class="logo_left">  
                <b-row align-h="center" >
                    <b-img  @click="gotoLang('ca')" src="@/images/logo-portada-generalitat.png" title="Català" fluid></b-img>
                </b-row>
            </b-col>
            <b-col :cols="$mq | mq({ mobile: 6, tablet: 6, laptop: 3, desktop:2 })" class="logo_right">                 
                <b-row align-h="center" >
                    <b-img  @click="gotoLang('es')" src="@/images/logo-portada-Bankia.png" title="Castellano" fluid></b-img>
                </b-row>
                
            </b-col>
        </b-row>
        
        <!-- Password modal -->
        <b-modal v-model="modalPasswordShow" :title="$t('slide0.text1')" effect="fade/zoom" 
        :ok-title="$t('slide0.text3')" :cancel-title="$t('slide0.text4')" @ok="fPassword"  @cancel="fPasswordCancel">
            <a target="_blank" :href="$t('slide0.text21')">{{$t('slide0.text20')}}</a>
            <form @submit.prevent="fPassword" role="form" method="post">
                <div class="form-group">
                    <label><p>{{ $t('slide0.text2') }}</p></label>
                    <b-form-input size="lg" type="password" class="text-center" v-model="slide0Password" ></b-form-input>
                    <h5 v-if="incorrectPassword" style="color:orange"><strong>{{ $t('slide0.text5') }}</strong></h5>

                </div>
            </form>
        </b-modal>

        <!-- Team data modal -->
        <b-modal v-model="modalRegisterPuntuationShow" :title="$t('slide0.text6')" effect="fade/zoom" 
            :ok-title="$t('slide0.text9')" :cancel-title="$t('slide0.text8')" @ok="fRegisterPuntuation" @cancel="fRegisterPuntuationCancel">
            <form @submit.prevent="fRegisterPuntuation" role="form" method="post" validated>
                <div class="form-group">
                    <b-row>
                        <label><h3>{{ $t('slide0.text7') }}</h3></label>
                    </b-row>
                    <label><p>{{ $t('slide0.text10') }}</p></label>
                    <b-form-input size="lg" class="text-center" v-model="slide0Escola" required></b-form-input>
                    <h6 v-if="!escolaValidated" style="color:red"><strong>{{ $t('slide0.text22') }}</strong></h6>
                    <label><p>{{ $t('slide0.text11') }}</p></label>
                    <b-form-input size="lg" class="text-center" v-model="slide0Equip" required></b-form-input>
                    <h6 v-if="!equipValidated" style="color:red"><strong>{{ $t('slide0.text22') }}</strong></h6>
                    <label><p>{{ $t('slide0.text12') }}</p></label>

                    <b-form-select v-model="slide0Curs" class="mb-3" required>
                        <option value="5e">{{ $t('slide0.text13') }}</option>
                        <option value="6e">{{ $t('slide0.text14') }}</option>
                        <option value="1r ESO">{{ $t('slide0.text15') }}</option>
                        <option value="2n ESO">{{ $t('slide0.text16') }}</option>
                        <option value="3r ESO">{{ $t('slide0.text17') }}</option>
                        <option value="4t ESO">{{ $t('slide0.text18') }}</option>
                        <option value="Altres">{{ $t('slide0.text19') }}</option>
                    </b-form-select>
                    <h6 v-if="!cursValidated" style="color:red"><strong>{{ $t('slide0.text22') }}</strong></h6>
                </div>
            </form>
        </b-modal>
    </div>

    
</template>

<script>
    import {mapState} from 'vuex';

    export default {    
        data(){
            return {
                modalPasswordShow: false,
                modalRegisterPuntuationShow: false,
                slide0Password:'',
                incorrectPassword: false,
                lang:'ca',
                slide0Escola:'',
                slide0Equip:'',
                slide0Curs:'',
                escolaValidated: true,
                equipValidated: true,
                cursValidated: true
            }
        },        
        computed:{
            ...mapState(['showMenu']),
        },
        methods:{
            gotoLang(lang){
                this.lang=lang;
                this.$i18n.locale=lang;
                this.$store.dispatch('updateVariable',{name: 'lang',value: lang});
                this.modalPasswordShow = true;                                
            },                       
            fPassword(bvModalEvt){
                bvModalEvt.preventDefault();
                if (this.slide0Password.trim()!=''){                   
                    this.incorrectPassword = false;
                    this.$store.dispatch('updateVariable',{name: 'slide0Password', value: this.slide0Password});
                    this.modalPasswordShow=false;
                    this.modalRegisterPuntuationShow=true;
                }else{                    
                    this.incorrectPassword = true;
                }
            },
            fPasswordCancel(){
                this.incorrectPassword = false;
            },
            fRegisterPuntuation(bvModalEvt){
                bvModalEvt.preventDefault();

                this.escolaValidated=(this.slide0Escola.trim().length>0);
                this.equipValidated=(this.slide0Equip.trim().length>0);
                this.cursValidated=(this.slide0Curs.trim().length>0);

                if(this.escolaValidated && this.equipValidated  && this.cursValidated){

                     this.$store.dispatch('updateVariable',{name: 'slide0Escola', value: this.slide0Escola});
                     this.$store.dispatch('updateVariable',{name: 'slide0Equip', value: this.slide0Equip});
                     this.$store.dispatch('updateVariable',{name: 'slide0Curs', value: this.slide0Curs});
                     this.$router.push({name:'slide1',params:{lang:this.lang}});
                }

            },
            fRegisterPuntuationCancel(){
                this.modalRegisterPuntuationShow=false;
                this.escolaValidated=true;
                this.equipValidated=true;
                this.cursValidated=true;
            },
            downloadWithVueResource(url,fileName) {     
                this.$http({
                    method: 'get',
                    url: url,
                    responseType: 'arraybuffer'
                })
                .then(response => {                
                    this.forceFileDownload(response,fileName) 
                })
                .catch(() => console.log('error occured'))        
            }
        },
        beforeCreate(){
            this.$store.dispatch('changeShowMenu',false);    
            this.$store.dispatch('calculateRandomPieces');        
        }    
    }
</script>


<style>

    .lang_icon_cat {
        height: 90px;
        position: absolute;
        margin: auto;
        display: block;
        top: 50%;
        left: -40%;
        right: 0;
    }

    .lang_icon_esp {
        height: 90px;
        position: absolute;
        margin: auto;
        display: block;
        top: 50%;
        left: 40%;
        right: 0;
    }

    .logo_right {
        height: 90px;
        position: absolute;
        margin: auto;
        display: block;
        right: 2%;
        bottom: 2%;
    }

    .logo_left {
        height: 90px;
        position: absolute;
        margin: auto;
        display: block;
        left: 2%;
        bottom: 2%;
    }

    .capcalera
    {
        position: absolute;
        text-align: center;
        display: inline-block;
        left: 0;
        right: 0;
        top: 10%;
    }

    .titol{
        font-size: 10vw;
    }

    .subtitol{
        font-size: 2vw;
    }

    .fons{
        /* Set rules to fill background */
        min-height: 100%;
        min-width: 1024px;
            
        /* Set up proportionate scaling */
        width: 100%;
        height: auto;
            
        /* Set up positioning */
        position: fixed;
        top: 0;
        left: 0;
    }

</style>